module.exports = __webpack_public_path__ + "media/images/site/fundamental1_premio-117143c1893de3cbc0cf624b67c35f19.jpg";